import React from 'react';

export const ContextMenuDivider = ({ name }: { name?: string }) => (
  <div className="context-menu-item-divider" data-test={name}>
    -
  </div>
);
